import React from "react";
import SimpleBanner from "../Common/SimpleBanner";
import AboutUs_banner from "../../Assets/About/banaraimg.png";
import RailwaySection from "../../Components/Project/RailwaySection.jsx";
import SubscribeTo from "../../Components/home/SubscribeTo.jsx";
const Projects = () => {
  return (
    <div className="overflow-x-hidden tracking-wide">
      <SimpleBanner
        image={AboutUs_banner}
        name="Gallery"
        path="Home / Gallery"
      />
      <RailwaySection />
      <SubscribeTo />
    </div>
  );
};

export default Projects;
